
const Login = (props) => {
    return (
        <div className="loginDiv">
            <h1 className="page-header">Under Construction</h1>
            <img className="loginImg" src="https://i.imgur.com/unMSTCA.jpg" />
        </div>
    )
}

export default Login